/* eslint-disable no-param-reassign */
import { Images, Tweens } from '@abcya/abcya_phaser';
import Phaser from 'phaser';

export default class StarField extends Phaser.GameObjects.Group {
  constructor(scene) {
    super(scene);

    for (let i = 0; i < 50; i++) {
      const star = this.addStar(i % 2 === 0 ? 'star' : 'diamond', Math.random() * .3 + .4);
      star.alpha = 0;
      star.tint = 0x24876b;

      this.scene.time.addEvent({ delay: i * 100, callback: () => {this.fadeIn(star);} });
    }
  }

  fadeIn(star) {
    star.x = Math.random() * this.scene.scale.width;
    star.y = Math.random() * this.scene.scale.height;

    Tweens.addTween(star, 500, { alpha: .6, completeDelay: 1500 }, Phaser.Math.Easing.Linear, () => {
      this.fadeOut(star);
    });
  }

  fadeOut(star) {
    Tweens.addTween(star, 500, { alpha: 0, completeDelay: 1500 }, Phaser.Math.Easing.Linear, () => {
      this.fadeOut(star);
    });

  }

  addStar(key, scale) {
    const star = this.create(0, 0, Images.DEFAULT_ATLAS, key);
    star.setScale(scale);
    return star;
  }
}